export class QuestionnaireTemplatesDeleteRequest {
  templateId: string

  constructor(templateId: string) {
    this.templateId = templateId
  }
}
